module.exports = __webpack_public_path__ + "ui-static/img/logo-large_light.b1c7b970.svg";